var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8132 6.99987C15.8132 7.24851 15.7145 7.48697 15.5387 7.66278C15.3628 7.8386 15.1244 7.93737 14.8757 7.93737H3.39136L7.41636 11.9616C7.59248 12.1377 7.69143 12.3766 7.69143 12.6257C7.69143 12.8747 7.59248 13.1136 7.41636 13.2897C7.24024 13.4658 7.00137 13.5648 6.7523 13.5648C6.50323 13.5648 6.26436 13.4658 6.08824 13.2897L0.463239 7.66471C0.375839 7.57762 0.306492 7.47412 0.259175 7.36017C0.211857 7.24621 0.1875 7.12404 0.1875 7.00065C0.1875 6.87726 0.211857 6.75509 0.259175 6.64113C0.306492 6.52718 0.375839 6.42368 0.463239 6.33659L6.08824 0.711587C6.17544 0.624381 6.27897 0.555205 6.39291 0.50801C6.50685 0.460814 6.62897 0.436523 6.7523 0.436523C6.87563 0.436523 6.99775 0.460814 7.11169 0.50801C7.22563 0.555205 7.32916 0.624381 7.41636 0.711587C7.50357 0.798793 7.57275 0.902321 7.61994 1.01626C7.66714 1.1302 7.69143 1.25232 7.69143 1.37565C7.69143 1.49898 7.66714 1.6211 7.61994 1.73504C7.57275 1.84898 7.50357 1.95251 7.41636 2.03971L3.39136 6.06237H14.8757C15.1244 6.06237 15.3628 6.16114 15.5387 6.33696C15.7145 6.51277 15.8132 6.75123 15.8132 6.99987Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.02ac4470c5cdc0021ec8a1578b5ebed3.svg";
export { ForwardRef as ReactComponent };